import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Switch } from "react-router";
import NoMatch from "./NoMatch";
var CustomSwitch = function (_a) {
    var children = _a.children;
    return (_jsxs(Switch, { children: [children, _jsx(NoMatch, {})] }));
};
export default CustomSwitch;
